<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-table
        ref="grid"
        title="연료사용량"
        tableId="grid"
        :columns="grid.columns"
        :gridHeight="grid.height"
        :data="grid.data"
        :usePaging="false"
        :hideBottom="false"
        :columnSetting="false"
        :gridHeightAuto="param.isFullScreen"
        :filtering="false"
        :isExcelDown="false"
        :editable="editable"
        @table-data-change="tableDataChange"
      >
        <!-- 버튼 영역 -->
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn label="LBLSAVE" icon="save" v-if="!param.isFullScreen && editable" @btnClicked="saveData" />
          </q-btn-group>
        </template>
      </c-table>
    </div>
  </div>
</template>
<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'daily-air-report-04',
  props: {
    param: {
      type: Object,
      default: () => ({
        plantCd: null,
        envAirDailyResultId: '',
        isFullScreen: false,
        dailyResultDt: '',
        approvalStatusCd: null,
        approvalTarget: false,
      }),
    },
  },
  data() {
    return {
      grid: {
        columns: [],
        data: [],
      },
      listUrl: '',
      saveUrl: '',
      unitItems: [],
    };
  },
  computed: {
    editable() {
      if (this.param.approvalTarget) {
        return true;
      } else if (this.param.approvalStatusCd !== null) {
        return false;
      } else {
        return this.$route.meta.editable
      }
    },
  },
  watch: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.listUrl = selectConfig.env.air.daily.fuel.list.url;
      this.saveUrl = transactionConfig.env.air.daily.fuel.save.url;
      this.getColums();
    },
    getColums() {
      this.$http.url = selectConfig.env.air.mst.fuel.list.url;
      this.$http.type = 'GET';
      this.$http.param = {plantCd: this.param.plantCd};
      this.$http.request((_result) => {
        this.$_.forEach(_result.data, item => {
          this.unitItems.push(
            {
              code: item.code,
              unitCd: item.airFuelUnitName,
            },
          )
        });
        this.grid.columns = [
          {
            name: 'envAirMstDischargeName',
            field: 'envAirMstDischargeName',
            label: '배출시설',
            align: 'center',
            sortable: false,
          },
          {
            name: 'envAirMstFuelId',
            field: 'envAirMstFuelId',
            label: '연료',
            align: 'center',
            style: 'width: 200px',
            sortable: false,
            type: 'select',
            comboItems: _result.data,
          },
          {
            name: 'fuelVolume',
            field: 'fuelVolume',
            label: '사용량',
            align: 'center',
            style: 'width: 150px',
            type: 'number',
            sortable: false,
          },
          {
            name: 'airFuelUnitName',
            field: 'airFuelUnitName',
            label: 'LBLUNIT',
            align: 'center',
            style: 'width: 80px',
            sortable: false,
          },
        ]
        this.getList();
      },);
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {envAirDailyResultId: this.param.envAirDailyResultId, plantCd: this.param.plantCd};
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    saveData() {
      let saveData = this.grid.data.filter( x => {
        return x.editFlag == 'U' || x.editFlag == 'C'
      });
      this.$_.forEach(saveData, item => {
        item.regUserId = this.$store.getters.user.userId;
        item.chgUserId = this.$store.getters.user.userId;
      });
      if(saveData.length > 0) {
        window.getApp.$emit('CONFIRM', {
          title: 'LBLCONFIRM',
          message: 'MSGSAVE', // 저장하시겠습니까?
          type: 'info',
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.saveUrl;
            this.$http.type = 'POST';
            this.$http.param = saveData;
            this.$http.request(() => {
              this.getList();
              window.getApp.$emit('ALERT', {
                title: '안내 ', /* 안내 */
                message: '저장되었습니다.', /* 저장되었습니다. */
                type: 'success', // success / info / warning / error
              });
            });
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      } else {
        window.getApp.$emit('ALERT', {
          title: '안내 ', /* 안내 */
          message: 'MSGNOCHANGEDATA', // 변경된 데이터가 없습니다., /* 변경된 데이터가 없습니다. */
          type: 'info', // success / info / warning / error
        });
      }
    },
    tableDataChange(props) {
      if (props.row['envAirMstFuelId'] !== null) {
        let filterData = this.$_.filter(this.unitItems, item => {
          return item['code'] === props.row['envAirMstFuelId']
        })
        this.$set(props.row, 'airFuelUnitName', filterData[0].unitCd);
      }
    },
  }
};
</script>
